module.exports = __webpack_public_path__ + "img/17_gov3_bc_logo_transparent.b400c23b.svg";